import { SupportTicketPriority, SupportTicketStatus, TicketReplyResponseType } from '@business/entities/SupportTicket';
import { TicketEmailsResponse, TicketEmailsType } from '@business/entities/SupportTicket/TicketEmailsResponse';

export function getPriorityName(priority: SupportTicketPriority) {
  switch (priority) {
    case SupportTicketPriority.normal:
      return 'Normal';
    case SupportTicketPriority.major:
      return 'Major';
    case SupportTicketPriority.critical:
      return 'Critical';
  }
}

export function getReplyResType(type: TicketReplyResponseType) {
  switch (type) {
    case TicketReplyResponseType.responded:
      return 'Send Reply';
    case TicketReplyResponseType.sendAndClosed:
      return 'Send and Close';
    case TicketReplyResponseType.createTicket:
      return 'Create Ticket';
    default:
      return 'Respond';
  }
}

export function allStatuses(exceptReplied = false) {
  if (exceptReplied) {
    return [SupportTicketStatus.open, SupportTicketStatus.closed, SupportTicketStatus.markNotification, SupportTicketStatus.markSpam];
  }
  return [
    SupportTicketStatus.open,
    SupportTicketStatus.replied,
    SupportTicketStatus.closed,
    SupportTicketStatus.markNotification,
    SupportTicketStatus.markSpam,
  ];
}

export function getStatusTitle(status: SupportTicketStatus, short = false, action = false) {
  switch (status) {
    case SupportTicketStatus.open:
      return 'Open';
    case SupportTicketStatus.replied:
      return 'Replied';
    case SupportTicketStatus.closed:
      return action ? 'Close' : 'Closed';
    case SupportTicketStatus.markNotification:
      return short ? 'Notification' : 'Mark Notification';
    case SupportTicketStatus.markSpam:
      return short ? 'Spam' : 'Mark Spam';
  }
}

export function getStatusIntent(status: SupportTicketStatus) {
  switch (status) {
    case SupportTicketStatus.open:
      return 'warning';
    case SupportTicketStatus.replied:
      return 'primary';
    case SupportTicketStatus.closed:
      return 'success';
    case SupportTicketStatus.markNotification:
      return 'dark';
    case SupportTicketStatus.markSpam:
      return 'danger';
  }
}

export function allPriorities() {
  return [SupportTicketPriority.normal, SupportTicketPriority.major, SupportTicketPriority.critical];
}

export function getPriorityColor(priority: SupportTicketPriority) {
  switch (priority) {
    case SupportTicketPriority.normal:
      return '#d5d6d7';
    case SupportTicketPriority.major:
      return '#FFCC00';
    case SupportTicketPriority.critical:
      return '#f46a6a';
  }
}

export function isBanner(type: TicketReplyResponseType) {
  if (type === TicketReplyResponseType.closed) return true;
  return false;
}

export function getEmails(emails: TicketEmailsResponse[], type: TicketEmailsType) {
  return emails
    .filter(item => item.type === type)
    .map(item => item.email)
    .filter(item => item);
}
